export enum CelebrationType {
	Anniversary = 'work_anniversary',
	Birthday = 'birthday',
	Welcome = 'welcome',
}
